import { useFormatPrice } from 'hooks/formatting/useFormatPrice';
import { PricePerUnit } from 'types/product';

type PricePerUnitWidgetProps = {
    pricePerUnit: PricePerUnit;
};

export const PricePerUnitWidget = ({ pricePerUnit }: PricePerUnitWidgetProps) => {
    const { formatPriceNumber: formatPrice } = useFormatPrice();

    return <div className="text-small font-normal">{`${formatPrice(pricePerUnit.price)}/${pricePerUnit.unit}`}</div>;
};
